import { render, staticRenderFns } from "./unlink-oauth-form.vue?vue&type=template&id=6e52930e&lang=pug&"
import script from "./unlink-oauth-form.vue?vue&type=script&lang=js&"
export * from "./unlink-oauth-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports